export default "__VITE_ASSET__BVRwKmYn__"